import React from 'react';
import {FormattedMessage} from "react-intl";
import {PrimaryButton} from "cstar-react-primitives";

import originRedirect from '../../utils/originRedirect';
import { useFormatMessage } from '../../intl/intlHooks'

import {CartTotalItems} from "./CartTotalItems";
import {emptyOrderSummaryMessages} from "./orderSummaryMessages";

export const InnerEmptyOrderSummary = () => {
    const formatMessage = useFormatMessage();
    return (
        <div className="empty-cart-box mall-box">
            <div className="empty-cart-box__header">
                <CartTotalItems quantity={0} />
            </div>
            <p className="empty-cart-box__text">
                <FormattedMessage {...emptyOrderSummaryMessages.emptyCartMessage} />
            </p>
            <div className="empty-cart-box__actions">
                <PrimaryButton
                    type='button'
                    btnText={formatMessage(emptyOrderSummaryMessages.shopButtonText)}
                    onClick={originRedirect}
                    cashbotName="orderSummary"
                />
            </div>
        </div>
    );
};

export const EmptyOrderSummary = InnerEmptyOrderSummary;
